import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from 'ui-kit-takeat';
import { Container } from './styles';
import { NavBar } from './styles';
import { FaHome, FaKey, FaTasks } from 'react-icons/fa';
import { PageTitle } from '~/components/PageTitle';

function Header() {
  const location = useLocation(); // Obtém a localização atual
  const [pathname, setPathname] = useState('');

  // Atualize o estado "pathname" sempre que a localização mudar
  useEffect(() => {
    setPathname(location.pathname);
  }, [location.pathname]);

  function getTitleName(path) {
    switch (path) {
      case '/profile/info':
        return 'Editar Meu Negócio';

      case '/profile/user-profile':
        return 'Alterar perfil';

      case '/profile/tasks':
        return 'Tarefas';
      default:
        break;
    }
  }

  return (
    <Container>
      <div>
        <PageTitle>{getTitleName(pathname)}</PageTitle>
      </div>

      <NavBar>
        <Link to={'/profile/info'}>
          <Button
            title="Meu Negócio"
            icon={<FaHome />}
            inverted={pathname !== '/profile/info'}
            onClick={() => {}}
          />
        </Link>
        <Link to={'/profile/user-profile'}>
          <Button
            title="Alterar perfil da conta"
            icon={<FaKey />}
            inverted={pathname !== '/profile/user-profile'}
            onClick={() => {}}
          />
        </Link>
        <Link to={'/profile/tasks'}>
          <Button
            title="Tarefas"
            icon={<FaTasks />}
            inverted={pathname !== '/profile/tasks'}
            onClick={() => {}}
          />
        </Link>
      </NavBar>
    </Container>
  );
}

export default Header;
